// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"carouselContainer__19zaM","container":"container__1ORdj","scrollableDiv":"scrollableDiv__2AUAr","headline":"headline__KGuaL","imageOnly":"imageOnly__T6ltQ"};